import React, { Suspense } from 'react';
import Loader from '../../../components/commons/helpers/loader/loader.component';

function NewLocationLandingPage({ page: { MainContent, breadCrumbList } }) {
  const HeroComponent = React.lazy(() =>
    import('./new-location-hero-component')
  );
  const ContentComponent = React.lazy(() =>
    import('./new-location-content-component')
  );

  return (
    <div className="locations-secondary-container">
      <Suspense fallback={<Loader />}>
        <HeroComponent
          MainContent={MainContent}
          breadCrumbList={breadCrumbList}
        />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <ContentComponent />
      </Suspense>
    </div>
  );
}

export default NewLocationLandingPage;
